import styled from '@emotion/styled';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { mediaQueryMobileLimit } from '../../../../../utils/constants';

export const DescriptionStyled = {
  Container: styled(Box) <any>`
    margin: 100px 94px auto;
    background: linear-gradient(
        rgba(53, 121, 186, 0.8),
        rgba(53, 121, 186, 0.8)
      ),
      url('/assets/room.png');
    background-size: 100%;
    border-radius: 10px;
    margin-bottom: 90px;
    height: 617px;

    @media (max-width: ${mediaQueryMobileLimit}px) {
      margin: 94px 10px;
      height: auto;
    }
  `,

  ContentContainer: styled(Box) <any>`
    max-width: 541px;
    margin-left: 163px;
    padding-top: 110px;

    @media (max-width: ${mediaQueryMobileLimit}px) {
      margin-left: 15px;
      margin-right: 15px;
      padding-top: 15px;
      padding-bottom: 15px;
    }
  `,

  Title: styled(Typography) <any>`
    font-size: 42px;
    font-weight: 600;
    color: #fff;
    line-height: 1.11;

    font-family: EncodeSans-Medium;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 28px;
    }
  `,

  Subtitle: styled(Typography) <any>`
    font-size: 18px;
    color: #fff;
    width: 503px;
    line-height: normal;
    font-family: EncodeSans-regular;
    margin: 35px 0px;

    @media (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 15px;
      width: 100%;
    }
  `,

  Button: styled(Button) <any>`
    width: 160px;
    height: 65px;
    background-color: white;
    border-radius: 0;
    font-size: 16px;
    font-weight: 600;
    text-transform: none;
    font-family: EncodeSans-Medium;
    &:hover {
      background-color: white;
    }
    @media (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 13px;
      width: 130px;
      height: 42px;
      margin-bottom: 10px;
    }
  `,

  Link: styled(Link) <any>`
    text-decoration: none;
    height: 72px;
  `,
};
